import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="bg-white py-20 md:py-28 px-6" data-id="element-149">
      <div className="max-w-reading mx-auto" data-id="element-150">
        <FadeIn data-id="element-151">
          <p className="text-3xl md:text-4xl font-serif text-forest italic mb-8 leading-relaxed" data-id="element-152">
            It's 8:00 PM on Sunday...
          </p>
          <div className="space-y-6 text-lg md:text-xl text-charcoal/90 font-light" data-id="element-153">
            <p data-id="element-154">
              You've had a "relaxing" weekend, but that familiar, cold knot is
              tightening in your stomach again. You're physically on your couch,
              but mentally, you're already drowning in tomorrow's emails,
              meetings, and expectations.
            </p>
            <p data-id="element-155">
              This isn't just "the blues." It's burnout-induced nervous system
              dread. And your 3-page To-Do list is only making it worse.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}